export default () =>
  new Proxy(
    {},
    {
      get: function () {
        return function () {};
      },
    }
  );
